"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepsModal = void 0;
var _proRegularSvgIcons = require("@fortawesome/pro-regular-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _core = require("@material-ui/core");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = _interopRequireDefault(require("react"));
var _StepsModal = require("./StepsModal.styles");
var _excluded = ["tabs", "currentSection", "title", "open", "setOpen", "children", "className", "onClose"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var StepsModal = function StepsModal(_ref) {
  var tabs = _ref.tabs,
    currentSection = _ref.currentSection,
    title = _ref.title,
    open = _ref.open,
    setOpen = _ref.setOpen,
    children = _ref.children,
    className = _ref.className,
    onClose = _ref.onClose,
    rest = _objectWithoutProperties(_ref, _excluded);
  var classes = (0, _StepsModal.useStyles)();
  var mapSectionToPercentage = function mapSectionToPercentage(section) {
    return Math.round(tabs.indexOf(currentSection) / (tabs.length - 1) * 100).toString() + '%';
  };
  var handleClose = function handleClose() {
    setOpen(false);
    onClose();
  };
  return /*#__PURE__*/_react["default"].createElement(_core.Modal, _extends({
    open: open,
    disableBackdropClick: true
  }, rest, {
    style: {
      display: 'flex'
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(classes.paper, className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.headerContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.title
  }, /*#__PURE__*/_react["default"].createElement("div", null, title), /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    onClick: handleClose,
    className: classes.close
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _proRegularSvgIcons.faTimes,
    style: {
      height: '15px',
      marginTop: '-7px',
      color: '#C3C3C3'
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.progress
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginLeft: "calc(".concat(mapSectionToPercentage(currentSection), " - 7.5px)"),
      width: '15px',
      height: '15px',
      borderRadius: '50%',
      backgroundColor: '#0C8375',
      position: 'relative',
      top: '10px'
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      backgroundColor: '#EFEFEF',
      height: '5px',
      borderRadius: '5px'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      backgroundColor: '#0C8375',
      height: '5px',
      borderRadius: '5px',
      width: mapSectionToPercentage(currentSection)
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      fontSize: '16px',
      marginTop: '5px'
    }
  }, tabs.map(function (tab, index) {
    return /*#__PURE__*/_react["default"].createElement(_core.Typography, {
      style: {
        color: tab === currentSection ? '#1E8777' : '#A0A0A0'
      },
      variant: "subtitle1",
      key: index
    }, index + 1, ". ", tab);
  })))), /*#__PURE__*/_react["default"].createElement("div", null, children)));
};
exports.StepsModal = StepsModal;